import TopBar from 'Components/TopBar';
import { Outlet } from 'react-router';

export interface IAppLayoutProps {}

export default function AppLayout(props: IAppLayoutProps) {
  return (
    <div className="app-layout">
      <TopBar />
      <Outlet />
    </div>
  );
}
